import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Button, CheckOutline, Flex, Input, Text, XOutline } from '@bonusly/design-system';

import { useBookmark } from '../../context';
import { useCreateLabels } from './hooks/use-create-label';
import { Label } from './lib/entities';

interface NewLabelProps {
	show: boolean;
	hideNewLabelForm: VoidFunction;
}

export const NewLabel: FC<NewLabelProps> = ({ show, hideNewLabelForm }) => {
	const { labelsIds, setLabelsIds } = useBookmark();
	const { t } = useTranslation('bookmarks');
	const [inputValue, setInputValue] = useState('');
	const createLabel = useCreateLabels({
		onSuccess: (label: Label) => {
			setLabelsIds([...(labelsIds ?? []), label.id]);
			hideNewLabelForm();
		},
	});

	if (!show) {
		return null;
	}

	const handleInputChange = (event: any) => {
		setInputValue(event.target.value);
	};

	const handleSubmit = (e: any) => {
		e.preventDefault();
		createLabel.mutate({ name: inputValue });
	};

	return (
		<Box w="full" p={4} bg="grayAlpha.100" borderRadius="md" mt={3}>
			<Text fontSize="sm" mb={2.5}>
				{t('bookmark_modal.new_label_name') || ''}
			</Text>

			<Flex gap={2} as="form" onSubmit={handleSubmit}>
				<Input
					onChange={handleInputChange}
					placeholder={t('bookmark_modal.new_label') || ''}
					backgroundColor="bg.surface"
					value={inputValue}
					fontSize="sm"
					type="text"
					autoFocus
				/>
				<Button aria-label={t('bookmark_modal.discard_new_label') || ''} onClick={hideNewLabelForm} colorScheme="secondary" variant="alpha" px={2}>
					<XOutline size="sm" />
				</Button>

				<Button aria-label={t('bookmark_modal.save_label') || ''} isDisabled={!inputValue.trim()} type="submit" px={2}>
					<CheckOutline size="sm" />
				</Button>
			</Flex>
		</Box>
	);
};
